// extracted by mini-css-extract-plugin
export default {"horse":"FlyingHorse_horse__UAeeh","fly":"FlyingHorse_fly__aWlCk","fly-across":"FlyingHorse_fly-across__nxFPi"};